import { RootState } from '@src/store/store'
import { PayStateType } from '@src/store/ducks/pay/reducer'

export const selectPay = (state: RootState): PayStateType => state.pay

export const selectPayIsLoading = (state: RootState) => selectPay(state).isLoading
export const selectRecurrentCard = (state: RootState) => selectPay(state).recurrentCard
export const selectIsSuccessCreditLimit = (state: RootState) => selectPay(state).isSuccessCreditLimit
export const selectIsLoadingCreditLimit = (state: RootState) => selectPay(state).isLoadingCreditLimit
export const selectBackError = (state: RootState) => selectPay(state).backError
export const selectCreditLimitDescription = (state: RootState) => selectPay(state).creditLimitDescription
